"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInputTd = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importDefault(require("react"));
var NumberInputTd = function (props) {
    var _a = props.cell, colSpan = _a.colSpan, value = _a.value, path = _a.path, rowSpan = _a.rowSpan;
    var onChangeV = props.onValueUpdate;
    var isValueUndefined = (value + '').trim() === '' || value === null || value === undefined;
    var displayError = props.required && isValueUndefined && props.triedSubmitting;
    return ((0, jsx_runtime_1.jsx)("td", __assign({ style: props.style, className: index_modules_css_1.default.gridTd, colSpan: colSpan, rowSpan: rowSpan }, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ className: index_modules_css_1.default.numberInputCell, validateStatus: displayError ? 'error' : undefined }, { children: (0, jsx_runtime_1.jsx)(antd_1.InputNumber, { style: { width: '100%', height: '100%', borderColor: displayError ? '#FF0000' : 'none' }, type: "number", required: props.required, onChange: function (state) { return (onChangeV || lodash_1.noop)(path, state); }, min: 0, defaultValue: value }) })) })));
};
exports.NumberInputTd = NumberInputTd;
